import { render, staticRenderFns } from "./LoginSetting.vue?vue&type=template&id=40b691ed&scoped=true"
import script from "./LoginSetting.vue?vue&type=script&lang=js"
export * from "./LoginSetting.vue?vue&type=script&lang=js"
import style0 from "./LoginSetting.vue?vue&type=style&index=0&id=40b691ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b691ed",
  null
  
)

export default component.exports